export { default } from "./starRating";
export type { StarRatingSize } from "./starRating";
